// ToDo: WW-7459 Move to shared shadow folder
import styles from '../../../../../../erp/components/tab-panels/positions/components/positions-table/PositionsTable.module.scss';

import clsx from 'clsx';
import React, { DetailedHTMLProps, HTMLAttributes, useRef } from 'react';

import { ReactComponent as DragIndicatorIcon } from '@work4all/assets/icons/drag-vertical.svg';

import { useUser } from '@work4all/data';

import { ServiceContractPosition } from '@work4all/models/lib/Classes/ServiceContractPosition.entity';
import { ServiceContractPositionKind } from '@work4all/models/lib/Enums/ServiceContractPositionKind.enum';

import { formatNumberAsCurrency } from '@work4all/utils';
import { canViewERPPrices } from '@work4all/utils/lib/permissions';

// ToDo: WW-7459 Move to shared shadow folder (2 below)
import { InfiniteRow } from '../../../../../../erp/components/tab-panels/positions/components/edit-table/InfiniteList';
import { useSelectedPositionState } from '../../../../../../erp/components/tab-panels/positions/components/hooks/use-selected-position';
import { useEditTable } from '../edit-table/components/edit-table-provider/EditTableProvider';
import { useEditTableDrag } from '../edit-table/components/TableRow/use-edit-table-drag';
import { useEditTableAllCells } from '../edit-table/hooks/use-edit-table-all-cells';
import { useEditableRow } from '../edit-table/hooks/use-editable-row';
import { EditTableProps } from '../edit-table/types';

interface PositionsMobileTableProps {
  position: ServiceContractPosition;
  setEditedPosition: (position: ServiceContractPosition) => void;
  allPositions: ServiceContractPosition[];
  editableRows?: EditTableProps<ServiceContractPosition>['editableRows'];
  columns?: EditTableProps<ServiceContractPosition>['columns'];
  decorators?: EditTableProps<ServiceContractPosition>['decorators'];
}

const wrapWithRow = (position: ServiceContractPosition) => {
  return {
    id: position.localId,
    index: position.index,
    original: position,
  } as unknown as InfiniteRow<ServiceContractPosition>;
};

export const PositionsMobileTable = (props: PositionsMobileTableProps) => {
  const {
    setEditedPosition,
    allPositions,
    position,
    columns,
    editableRows,
    decorators,
  } = props;

  const { onMoveComponent } = useEditTable();
  const allCells = useEditTableAllCells<ServiceContractPosition>(columns);

  const data = useRef(allPositions);
  data.current = allPositions;

  const { calculateRowProperties } = useEditableRow({
    allCells,
    data,
    decorators,
    editableRows,
    onMoveComponent,
  });

  const { canDrop, handleMoveRow } = calculateRowProperties(
    wrapWithRow(position)
  );

  const { direction, isDragging, isOver, dropRef, dragRef } = useEditTableDrag<
    HTMLTableRowElement,
    HTMLTableCellElement
  >({
    canDrop,
    index: allPositions.findIndex((x) => x.localId === position.localId),
    localId: position.localId,
    moveRowDone: handleMoveRow,
  });

  const user = useUser();
  const showPrices = canViewERPPrices(user);

  const { setSelectedPositionIds } = useSelectedPositionState();

  const key = position.id;

  const dragStyle: React.CSSProperties = {
    opacity: 1,
    userSelect: 'none',
    WebkitUserSelect: 'none',
  };
  const rowProps: DetailedHTMLProps<
    HTMLAttributes<HTMLTableRowElement>,
    HTMLTableRowElement
  > = {
    style: dragStyle,
    className: isDragging ? styles.noselect : undefined,
    onContextMenu: (e) => e.preventDefault(),
  };

  const dragCell = (
    <td ref={dragRef}>
      <DragIndicatorIcon />
    </td>
  );

  const getRow = () => {
    switch (position.positionKind) {
      case ServiceContractPositionKind.UEBERSCHRIFT:
      case ServiceContractPositionKind.TEXTZEILE:
        return (
          <tr
            ref={dropRef}
            style={dragStyle}
            key={key}
            onClick={() => {
              setEditedPosition(position);
              setSelectedPositionIds([position.id]);
            }}
            className={clsx(
              styles.title,
              styles.mobilePositionRow,
              rowProps.className,
              {
                [styles.text01]:
                  position.positionKind ===
                  ServiceContractPositionKind.UEBERSCHRIFT,
              }
            )}
          >
            {dragCell}
            <td></td>
            <td>{position.number}</td>
            <td style={{ width: '100%' }}>
              {position.positionKind !==
                ServiceContractPositionKind.UEBERSCHRIFT &&
                showPrices && (
                  <span style={{ float: 'right' }}>
                    {formatNumberAsCurrency(position.purchasePrice)}
                  </span>
                )}
              <div style={{ whiteSpace: 'pre-line' }}>{position.longtext}</div>
            </td>
          </tr>
        );
      default:
        return (
          <tr
            ref={dropRef}
            key={key}
            className={clsx(styles.mobilePositionRow, rowProps.className)}
            style={dragStyle}
          >
            {dragCell}
            <td
              className={styles.positionNumberCell}
              onClick={() => {
                setEditedPosition(position);
                setSelectedPositionIds([position.id]);
              }}
            >
              {position.number}
            </td>
            <td
              style={{ width: '100%' }}
              onClick={() => {
                setEditedPosition(position);
                setSelectedPositionIds([position.id]);
              }}
            >
              <div style={{ whiteSpace: 'pre-line' }}>{position.longtext}</div>

              <div className={styles.subline}>
                <div className={styles.left}>
                  {showPrices && (
                    <span>{formatNumberAsCurrency(position.price)}</span>
                  )}
                  {showPrices && position.discount > 0 && (
                    <span>{position.discount} %</span>
                  )}
                </div>
                {showPrices && (
                  <div className={styles.right}>
                    {formatNumberAsCurrency(position.purchasePrice)}
                  </div>
                )}
              </div>
            </td>
          </tr>
        );
    }
  };

  return (
    <React.Fragment key={key}>
      {isOver && direction === 'up' ? (
        <tr className={styles['highlight-row']}>
          <td colSpan={4} />
        </tr>
      ) : undefined}
      {getRow()}
      {isOver && direction === 'down' ? (
        <tr className={styles['highlight-row']}>
          <td colSpan={4} />
        </tr>
      ) : undefined}
    </React.Fragment>
  );
};
